import { Briefcase, UserCheck, Send, Clock } from 'lucide-react';

interface LeadStatsProps {
  totalLeads: number;
  acceptedLeads: number;
  requestedLeads: number;
  openLeads: number;
}

export function LeadStats({ totalLeads, acceptedLeads, requestedLeads, openLeads }: LeadStatsProps) {
  return (
    <div className="project-stats grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <div className="project-stat project-stat--neutral bg-white border border-gray-200 rounded-lg p-6">
        <div className="flex items-center justify-between mb-2">
          <span className="text-gray-600 text-sm">Total Leads</span>
          <Briefcase className="w-5 h-5 text-gray-400" />
        </div>
        <div className="text-3xl font-semibold">{totalLeads}</div>
      </div>

      <div className="project-stat project-stat--green bg-white border border-gray-200 rounded-lg p-6">
        <div className="flex items-center justify-between mb-2">
          <span className="text-gray-600 text-sm">Accepted</span>
          <UserCheck className="w-5 h-5 text-green-600" />
        </div>
        <div className="text-3xl font-semibold text-green-600">{acceptedLeads}</div>
      </div>

      <div className="project-stat project-stat--blue bg-white border border-gray-200 rounded-lg p-6">
        <div className="flex items-center justify-between mb-2">
          <span className="text-gray-600 text-sm">Requested</span>
          <Send className="w-5 h-5 text-blue-600" />
        </div>
        <div className="text-3xl font-semibold text-blue-600">{requestedLeads}</div>
      </div>

      <div className="project-stat project-stat--orange bg-white border border-gray-200 rounded-lg p-6">
        <div className="flex items-center justify-between mb-2">
          <span className="text-gray-600 text-sm">Open</span>
          <Clock className="w-5 h-5 text-orange-600" />
        </div>
        <div className="text-3xl font-semibold text-orange-600">{openLeads}</div>
      </div>
    </div>
  );
}
